/* eslint-disable react/jsx-pascal-case */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  BackgroundArea,
  RowView,
} from "../../../../Component/style/common_style";
import { promises } from "dns";

export interface ModalOpen {
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  text: String;
  onClose?: () => void;
  type: String;
}

const Overlay = styled(BackgroundArea)`
  background-color: rgba(0, 0, 0, .32);
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: calc(100% - 32px);
  max-width: 27rem;
  margin: auto 0rem;
  background-color: var(--user-surface-raised);
  border: 1px solid var(--user-border);
  box-shadow: 0 16px 48px rgba(0, 0, 0, .3);
  color: var(--user-text);
  border-radius: 24px;
  overflow: hidden;
  padding: 24px 24px 30px 24px;
  z-index: 99;
  color: var(--user-text);
  div.info {
    line-height: 1.6;
    overflow-wrap: anywhere;
  }
`;

const Content_Box = styled.div`
  padding: 44px 0px 44px 0px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  color: var(--user-text);
`;

const BtnArea = styled(RowView)`
  button {
    border: 0;
    min-height: 48px;
    font-size: 16px;
    flex: 1;
    padding: 0.8rem 0rem;
    font-family: var(--font-Pretendard-SemiBold);
    text-align: center;
    color: white;
    background: linear-gradient(90deg, #7955f0, #3209b9);
    border-radius: 8px;
    cursor: pointer;
    &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 3px; }
  }
`;

const Basic_Modal = (props: ModalOpen) => {
  const isOpen = props.visible;
  const setIsOpen = props.handleModal;
  const text = props.text;
  const Navigate = useNavigate();
  const go_home = () => Navigate("/", { replace: true });
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);

  const Close = () => {
    setIsOpen(false);
  };

  // useEffect(() => {
  //   if (isOpen) {
  //     timeoutIdRef.current = setTimeout(() => {
  //       Close();
  //     }, 10000);

  //     // 클린업 함수에서 타이머를 정리
  //     return () => {
  //       if (timeoutIdRef.current) {
  //         clearTimeout(timeoutIdRef.current);
  //         timeoutIdRef.current = null;
  //       }
  //     };
  //   }
  // }, [isOpen]);

  const handleClose = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
    if (props.type === "item_list") {
      if (text.includes("재고") || text.includes("아닙니다")) {
        props.onClose && props.onClose();
      }
    }
    Close();
  };

  // console.log(props.type);

  return (
    <Overlay style={isOpen ? {} : { display: "none" }} translate="no"
      onClick={event => { if (event.target === event.currentTarget) handleClose(); }}>
      <ModalBox role="alertdialog" aria-modal="true" aria-label="구매 안내" onClick={event => event.stopPropagation()}>
        <Content_Box className="info">{text}</Content_Box>

        <BtnArea>
          <button type="button" onClick={handleClose}>확인</button>
        </BtnArea>
      </ModalBox>
    </Overlay>
  );
};

export default Basic_Modal;
